/**
 * Created by mac on 3/14/18
 */

const PlaySession = function () {
    this.load();
    
    connector.metrics.on("flush", this.onFlush.bind(this));
    connector.metrics.on("startSession", this.onStartSession.bind(this));
    connector.metrics.on("startDay", this.onStartDay.bind(this));
    connector.metrics.on("updateTimeIncrement", this.onActiveTimeIncrement.bind(this));

    this.logEventOnce = (name, params) => cleverapps.whenAllInitialized(() => this._logEventOnce(name, params));
    this.logAbtestEventOnce = (name, params) => cleverapps.whenAllInitialized(() => this._logAbtestEventOnce(name, params));
};

PlaySession.prototype.load = function () {
    let info = cleverapps.dataLoader.load(DataLoader.TYPES.PLAY_SESSION);
    if (!info) {
        info = {};
    }

    this.data = info;
};

PlaySession.prototype.save = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.PLAY_SESSION, this.data);
};

PlaySession.prototype.getInfo = function () {
    return this.data;
};

PlaySession.prototype.updateInfo = function (serverData) {
    this.data = serverData || {};
    this.save();
};

PlaySession.prototype.onStartDay = function () {
    this.data = {};
    this.save();
    PlaySession.StartDayListeners.forEach((listener) => {
        listener();
    });
};

PlaySession.prototype.onActiveTimeIncrement = function () {
    PlaySession.ActiveTimeListeners.forEach((listener) => {
        listener();
    });
};

PlaySession.prototype.inc = function (key, value, field) {
    if (value === undefined) {
        value = 1;
    }
    let oldValue = this.data[key];
    if (oldValue === undefined) {
        oldValue = 0;
    }

    if (field) {
        oldValue = oldValue || {};
        oldValue[field] = oldValue[field] ? oldValue[field] + value : value;
    }
    const newValue = field ? oldValue : oldValue + value;
    this.set(key, newValue);
};

PlaySession.prototype.set = function (key, value, field) {
    if (field !== undefined) {
        this.data[key] = this.data[key] || {};
        this.data[key][field] = value;
    } else {
        this.data[key] = value;
    }

    this.save();
};

PlaySession.prototype.get = function (key) {
    return this.data[key];
};

PlaySession.prototype.onFlush = function (data) {
    data = data || {};
    PlaySession.FlushListeners.forEach((listener) => {
        listener(data);
    });
};

PlaySession.prototype.onStartSession = function (data) {
    data = data || {};
    PlaySession.StartSessionListeners.forEach((listener) => {
        listener(data);
    });
};

PlaySession.prototype._logEventOnce = function (name, params) {
    params = params || {};
    const key = params.key || name;
    if (this.get(key)) {
        return;
    }

    this.logEvent(name, params);
    this.set(key, true);
};

PlaySession.prototype.logAvg = function (name, params = {}) {
    this.logEventOnce(`${name}_dau`, { ...params, value: 1 });
    this.logEvent(name, params);
};

PlaySession.prototype.logDistribution = function (name, value, brackets) {
    const sorted = brackets.slice().sort((a, b) => a - b);

    let group = 0;
    for (; group < sorted.length; group++) {
        if (value <= sorted[group]) {
            break;
        }
    }

    this.logEvent(`${name}-${group}`);
};

PlaySession.prototype._logAbtestEventOnce = function (name, params) {
    params = params || {};
    const key = params.key || name;
    if (this.get(key)) {
        return;
    }

    this.logAbtestEvent(name, params);
    this.set(key, true);
};

PlaySession.prototype.logEvent = function (event, params) {
    params = params || {};
    params.event = params.event || connector._metrics.getDayStart();
    cleverapps.metrics.logEvent(event, params);
};

PlaySession.prototype.logAbtestEvent = function (event, params) {
    params = params || {};
    params.event = params.event || connector._metrics.getDayStart();
    cleverapps.abExperiments.allLogEvent(event, params);
};

PlaySession.AbtestDayReporter = function () {
    const daysSinceRegistration = cleverapps.user.getDaysSinceRegistration();

    const retentionEvent = connector.EVENTS.STATS[`RETENTION_${daysSinceRegistration}`];
    if (retentionEvent) {
        cleverapps.playSession.logAbtestEvent(retentionEvent, { expedition: "main", withFutureGroups: true });
    }

    cleverapps.playSession.logAbtestEvent(connector.EVENTS.STATS.DAU, { expedition: "main" });

    if (connector.social.isLoggedIn()) {
        cleverapps.playSession.logAbtestEvent(`${connector.EVENTS.STATS.DAU}_logged_in`, { expedition: "main" });
    }
};

PlaySession.SettingsReporter = function () {
    cleverapps.whenAllInitialized(() => {
        const webpSupport = Boolean(cleverapps.config.webpSupport);

        cleverapps.playSession.logEvent(cleverapps.EVENTS.STATS.RESOLUTION + cleverapps.resolution.resolutionName);
        cleverapps.playSession.logEvent(cleverapps.EVENTS.STATS.WEBP + webpSupport);
        cleverapps.playSession.logEvent(cleverapps.EVENTS.STATS.DEVICE, { itemId: connector.info.isMobile ? "mobile" : "desktop" });

        const fingerprint = DeviceFingerprint.calculate();
        cleverapps.playSession.logEvent(cleverapps.EVENTS.STATS.DEVICE_FINGERPRINT, {
            itemId: fingerprint.relaxed,
            details: { strict: fingerprint.strict, traits: fingerprint.traits }
        });

        if (engine === "cocos2d" && cc._renderType === cc.game.RENDER_TYPE_CANVAS) {
            cleverapps.playSession.logEvent(cleverapps.EVENTS.STATS.CANVAS_RENDERER);
        }

        if (connector.platform.oneOf(connector.WECHAT)) {
            cleverapps.playSession.logEvent(cleverapps.EVENTS.STATS.OS + connector.info.os);
            cleverapps.playSession.logEvent(cleverapps.EVENTS.STATS.PLATFORM + connector.info.platform);
        }

        if (connector.info.androidVersion) {
            cleverapps.playSession.logEvent(cleverapps.EVENTS.STATS.ANDROID_VERSION + connector.info.androidVersion);
        }
    });
};

PlaySession.LocalPushesReporter = function () {
    if (connector.notifications.isPermitted()) {
        cleverapps.playSession.logEvent(cleverapps.EVENTS.STATS.PUSHES.PERMITTED_DAU);
    }
};

PlaySession.AbtestFlushReporter = function (data) {
    const location = cleverapps.meta.getSelectedLocation();

    let event = connector.EVENTS.STATS.ACTIVE_TIME;
    cleverapps.playSession.logAbtestEventOnce(`${event}_count`, { event: data.dayStart, expedition: "main" });
    cleverapps.playSession.logAbtestEvent(event, { event: data.dayStart, value: data.activeTime, expedition: "main" });

    if (!location.locationConfig.isMain) {
        const locationId = location.locationId;
        event += locationId;
        cleverapps.playSession.logAbtestEventOnce(`${event}_count`, { event: data.dayStart, expedition: locationId });
        cleverapps.playSession.logAbtestEvent(event, { event: data.dayStart, value: data.activeTime, expedition: locationId });
    }
    
    cleverapps.playSession.logAbtestEvent(connector.EVENTS.STATS.SESSION_TIME, { event: data.sessionStart, value: data.activeTime });
};

PlaySession.AbtestStartSessionReporter = function () {
    cleverapps.playSession.logAbtestEventOnce(`${connector.EVENTS.STATS.SESSION_TIME}_count`);
};

PlaySession.FlushListeners = [
    PlaySession.AbtestFlushReporter
];

PlaySession.StartSessionListeners = [
    PlaySession.AbtestStartSessionReporter
];

PlaySession.StartDayListeners = [
    PlaySession.SettingsReporter,
    PlaySession.AbtestDayReporter,
    PlaySession.LocalPushesReporter
];

PlaySession.ActiveTimeListeners = [

];